import { useState } from 'react'
import { CustomButton } from 'components/ui'
import { Tooltip } from 'react-tooltip'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import ModalEditUserRole from './EditRoleModal'

const EditRoleProyectoButton = ({ user, rol }) => {
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <div className="delete-user-button-proyecto-container">
        <CustomButton
          type="light"
          className="btn-sxm edit-role-user-project"
          onClick={() => setOpenModal(true)}
        >
          <EditOutlinedIcon sx={{ fontSize: '2rem' }} />
        </CustomButton>
      </div>

      <Tooltip
        anchorSelect=".edit-role-user-project"
        style={{ fontSize: '9px' }}
      >
        Editar rol usuario
      </Tooltip>

      {openModal && (
        <ModalEditUserRole
          user={user}
          rol={rol}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  )
}

export default EditRoleProyectoButton
